/**
 * Copyright IBM Corp. 2022, 2026
 */

import { MDSButton } from '@hashicorp/mds-react/components'
import s from './RelatedContent.module.css'

export default function RelatedContent({
	eyebrow,
	title,
	summary,
	link,
	brand,
}) {
	return (
		<section className={s.relatedContentSection}>
			{/* eslint-disable-next-line react/jsx-no-target-blank */}
			<a
				href={link.url}
				className={s.relatedContent}
				rel={link.type === 'outbound' ? 'noopener' : undefined}
				target={link.type === 'outbound' ? '_blank' : undefined}
			>
				<div className={s.infoWrapper}>
					<span className={s.eyebrow}>{eyebrow}</span>
					<h6 className={s.title}>{title}</h6>
					<span className={s.summary}>{summary}</span>
				</div>
				{link.text ? (
					<div className={s.buttonWrapper}>
						<MDSButton
							title={link.text}
							linkType={link.type}
							theme={{ variant: 'tertiary', brand: brand }}
						/>
					</div>
				) : null}
			</a>
		</section>
	)
}
